import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';

export const popupApi = createApi({
    baseQuery,
    reducerPath: 'popupApi',
    tagTypes: ['popup'],
    endpoints: (builder) => ({
        getPopupList: builder.query({
            query: () => ({
                url: `/data/popup/`,
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            providesTags: ['popup'],
        }),
        createPopup: builder.mutation({
            query: (data) => ({
                url: '/admin/users/popup',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['popup'],
        }),
        getImageLink: builder.mutation({
            query: (data) => ({
                url: `/admin/blog/get-image-link`,
                method: 'POST',
                body: data,
            }),
        }),
    }),
});

export const {
    useGetPopupListQuery,
    useCreatePopupMutation,
    useGetImageLinkMutation,
} = popupApi;
